<template>
  <div class="">
    <!-- header start -->
    <van-nav-bar title="追忆文章" left-arrow fixed :z-index="99" @click-left="onClickLeft" :border="false">
      <!-- <template #right>
        <van-icon name="edit" @click="onClickRight"/> 
      </template> -->
    </van-nav-bar>
    <div class="navBarSpace"></div>
    <!-- header end -->
    
    <div>
      <div class="article-header van-hairline--bottom">
        <h2 class="title">{{MemorialArticleApiModel.Title}}</h2>
        <div class="user-box">
          <div class="hd">
            <van-image
              round
              width="100%"
              height="100%"
              fit="cover"
              v-bind:src="MemorialArticleApiModel.MemberApiModel != null? MemorialArticleApiModel.MemberApiModel.HeadPic : ''"
            />
          </div>
          <div class="bd">
            <div class="name">{{MemorialArticleApiModel.MemberApiModel != null? MemorialArticleApiModel.MemberApiModel.NickName : ''}}</div>
            <p class="date">发布时间：{{MemorialArticleApiModel.MemberApiModel != null?$moment(MemorialArticleApiModel.AddDateTime).format('YYYY-MM-DD'):""}}</p>
          </div>
          <div class="ft">
            <van-icon v-if="isSelf" name="delete" @click="isdel" />
          </div>
        </div>
      </div>
      <div class="article-body">
        <div id="context" v-html="MemorialArticleApiModel.Content" class="rich"></div>
        <!-- <p>
        姚贝娜，一个从青歌赛走姚贝娜街拍出来的女孩，-个
        对音乐的态度执着和自信的女孩，娴熟地穿行于经典与流行
        歌曲之间。</p>
         <p>四岁开始学习钢琴，从此姚贝娜在父母的精心培养下对
        音乐产生了浓厚的兴趣，九岁第一-次登台演唱。童年时期参
        加多首歌曲的录制及现场演唱，多次在全国、省、市级的歌
        唱比赛中获奖。</p>
        <p>
        姚贝娜，一个从青歌赛走姚贝娜街拍出来的女孩，-个
        对音乐的态度执着和自信的女孩，娴熟地穿行于经典与流行
        歌曲之间。</p>
         <p>四岁开始学习钢琴，从此姚贝娜在父母的精心培养下对
        音乐产生了浓厚的兴趣，九岁第一-次登台演唱。童年时期参
        加多首歌曲的录制及现场演唱，多次在全国、省、市级的歌
        唱比赛中获奖。</p>
        <p>
        姚贝娜，一个从青歌赛走姚贝娜街拍出来的女孩，-个
        对音乐的态度执着和自信的女孩，娴熟地穿行于经典与流行
        歌曲之间。</p>
         <p>四岁开始学习钢琴，从此姚贝娜在父母的精心培养下对
        音乐产生了浓厚的兴趣，九岁第一-次登台演唱。童年时期参
        加多首歌曲的录制及现场演唱，多次在全国、省、市级的歌
        唱比赛中获奖。</p>
        <p>
        姚贝娜，一个从青歌赛走姚贝娜街拍出来的女孩，-个
        对音乐的态度执着和自信的女孩，娴熟地穿行于经典与流行
        歌曲之间。</p>
         <p>四岁开始学习钢琴，从此姚贝娜在父母的精心培养下对
        音乐产生了浓厚的兴趣，九岁第一-次登台演唱。童年时期参
        加多首歌曲的录制及现场演唱，多次在全国、省、市级的歌
        唱比赛中获奖。</p> -->
      </div>

      <van-divider />
      <div v-if="nickNameList.length > 0" class="zanBox"><span class="member">{{nickNameList.join('、')}}</span> 共<i class="num">{{nickNameList.length}}</i>人觉的很赞</div>

      <div class="appbarSpace"></div>
      <div class="van-hairline--top appbarBottom">
        <div :class="goodJobActive" @click="addGoodJob(currentToken.isLogin)" >
          <van-icon name="good-job" />
          <span class="text">点赞</span>
        </div>
        <!-- <router-link to="#" class="item">
          <van-icon name="balance-o" />
          <span class="text">打赏</span>
        </router-link> -->
        <router-link :to="{path:'/MemoryComment?memorialArticleID=' + this.memorialArticleID}" class="item">
          <van-icon name="comment" />
          <span class="text">评论</span>
        </router-link>
        <div class="item" @click="shareHandler">
          <van-icon name="share" />
          <span class="text">分享</span>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
  import soshm from 'soshm';
  import { mapGetters } from 'vuex';
  import { Toast, Dialog } from "vant";
  export default {
    data() {
      return {
        id : 0,
        memorialArticleID: "",
        MemorialArticleApiModel : [],
        nickNameList: [],
        isLogin: false,
        isSelf : false,
        goodJobActive: {
          "item" : true,
          "active" : false,
        },
        muid : "",
      };
    },
    computed:{
      ...mapGetters(["currentToken"])
    },
    components: {
    },
    created(){
      this.id = this.$route.query.id;
      this.memorialArticleID = this.$route.query.memorialArticleID;
      var memorialHallID =  this.$route.query.MemorialHallID;
      if(memorialHallID){
        this.muid = memorialHallID;
      }else{
        this.muid = this.$store.state.muid;
      }
      if(this.currentToken.isLogin){
        this.getIsSelfMemorialHall();     // 获取权限  
      }
      this.getMemorialArticleDetailed();  // 获取详情
    },
    methods: {
      onClickLeft() {
        this.$back();
        //this.$router.go(-1)
      },
      onClickRight(){

      },
      /**推荐给朋友**/
      shareHandler(){
        // soshm.popIn({
        //   title: '弹窗分享',
        //   sites: ['weixin', 'weixintimeline', 'weibo', 'qzone', 'tqq', 'qq']
        // });
        if(this.$weixin.IsWeiXin()){
          soshm.weixinSharetip();
        }else{
          Toast('当前暂不支持分享');
        }
        
      },
      getMemorialArticleDetailed(){
        var _this = this;
        this.$store
          .dispatch({
            type: "getMemorialArticleDetailed",
            id : _this.id,
          })
          .then(result => {
            _this.MemorialArticleApiModel = result.MemorialArticleApiModel;
            if (result.CommandPraiseApiModelList != null && result.CommandPraiseApiModelList.length > 0){
              for(var i=0; i< result.CommandPraiseApiModelList.length; i++){
                _this.nickNameList.push(result.CommandPraiseApiModelList[i].MemberApiModel.NickName);

                // 判断是否有点赞
                if(_this.currentToken.isLogin){
                  if(result.CommandPraiseApiModelList[i].MemberApiModel.MemberID == _this.currentToken.memberID){
                    _this.goodJobActive["active"] = true;
                  }
                }
              }
            }
            if(_this.$weixin.IsWeiXin()){
              _this.initweixinShare();
            }
        });
      },
      addGoodJob(isLogin){
        if(!isLogin){
          Toast("请登录后再进行点赞！");
          return;
        }
        var _this = this;
        // 已经是点赞了的
        // if(_this.goodJobActive["active"]){
        //   return;
        // }
        this.$store.dispatch({
          type: "addFacePraise",
          "articleId": _this.memorialArticleID,
        }).then(result => {
          
          if(result.IsSuccess){
            // 更改点赞颜色
            _this.goodJobActive["active"] = result.StateValue == "1";
            // 判断是否点赞，然后更改页面信息
            if(result.StateValue == "1"){
              _this.nickNameList.push(result.Information);
            }else{
              var index = _this.nickNameList.indexOf(result.Information);
              if(index > -1){
                _this.nickNameList.splice(index, 1);
              }
            }
            Toast(result.Message);
          }else{
            Toast(result.Message);
          }
        });
      },
      getIsSelfMemorialHall(){
        var _this = this;
        this.$store.dispatch({
          type: "getIsSelfMemorialHall",
          "Mid" :  _this.muid,
          "id" : 0,
        }).then(res => {
          //console.log(res);
          _this.isSelf = res;
        }).catch(err =>{})
      },
      isdel(){
        Dialog.confirm({
            title: "系统提示",
            message: '是否删除此文章？'
          }).then(() => {
            if(this.currentToken.isLogin){
              this.$store.dispatch({
                type : "DelMemorialArticleVue",
                id: this.id,
              }).then(res => {
                Toast(res.Message);
                if(res.IsSuccess){
                  this.$router.go(-1);
                }
              })
            }

          }, () => {});
        
      },
      initweixinShare(){
        var that = this;
        this.$nextTick(() => {
          var desc = document.querySelector("#context").innerText;
          if(!desc){
            desc = that.MemorialArticleApiModel.Title;
          }
          that.$weixin.ShareWeiXinAppMessage(
            that.MemorialArticleApiModel.Title,
            desc,
            that.MemorialArticleApiModel.CoverPhoto
          );
        })
        
      }
    },
  };
</script>

<style scoped>
.article-header{
  padding: 15px;
}
.article-header>.title{
  font-size: 17px;
  font-weight: normal;
  line-height: 1.5;
  margin-bottom: 10px;
}
.user-box{
  display: flex;
  align-items: center;
}
.user-box>.hd{
  width:32px;
  height: 32px;
  margin-right: 10px;
}
.user-box>.bd{
  flex: 1;
  overflow: hidden;
}
.user-box>.bd>.name{
  font-size: 13px;
  color: #555;
  white-space: nowrap;
  text-overflow: ellipsis;
  overflow: hidden;
}
.user-box>.bd>.date{
  font-size: 12px;
  color: #999;
  white-space: nowrap;
  text-overflow: ellipsis;
  overflow: hidden;
}
.user-box>.ft{
  margin-left: 15px;
}
.user-box>.ft>.van-icon{
  font-size: 24px;
  color: #888;
}
.article-body{
  padding: 15px;
}
.zanBox{
  color: #666;
  font-size: 12px;
  text-align: center;
  margin: 20px auto 30px;
}
.zanBox .member{
  color:lightskyblue;
}
.zanBox .num{
  color: #fc6620;
  font-style: normal;
}
.rich>>> img{ display:block; max-width: 100%}
</style>
